import { httpV1 as http } from '@/services/api';

export async function list(params) {
  return http.get('/private-payroll/auction/hot-leads', { params });
}

export async function downloadCSV(params) {
  return http.get('/private-payroll/auction/hot-leads/export', { params });
}

export async function enrich(id) {
  return http.put(`/private-payroll/auction/hot-leads/${id}/enrich`);
}

export async function dismiss(id) {
  return http.put(`/private-payroll/auction/hot-leads/${id}/dismiss`);
}

export async function restore(id) {
  return http.delete(`/private-payroll/auction/hot-leads/${id}/dismiss`);
}
